import { FilterValue, GroupFilter } from "../../types/filter";
import { AccordionGroup } from "../FilterAccordion/AccordionGroup";

interface InputGroupOptionProps {
  filter: GroupFilter;
  filterValues: FilterValue[];
  openFilters: string[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  onOpenChange: (isOpen: boolean) => void;
}

export const InputGroupOption = ({
  filter,
  filterValues,
  openFilters,
  setFilterValues,
  onOpenChange,
}: InputGroupOptionProps) => {
  return (
    <AccordionGroup
      filter={filter}
      filterValues={filterValues}
      setFilterValues={setFilterValues}
      open={!!openFilters.find((filterId) => filterId === filter.id)}
      onOpenChange={onOpenChange}
    />
  );
};
